import React, { useState, SyntheticEvent } from 'react';

interface IProps {
    url: string;
    alt: string;
    thresholdWidth: number;
    thresholdHeight: number;
}

const ConditionalImage: React.FC<IProps> = ({ 
    url, 
    alt, 
    thresholdWidth, 
    thresholdHeight 
}) => {
    const [show, setShow] = useState(true);

    const checkDimensions = (event: SyntheticEvent<HTMLImageElement, Event>) => {
        const target = event.currentTarget;

        if (target == null) {
            return;
        }

        const imgWidth = target.naturalWidth;
        const imgHeight = target.naturalHeight;
        
        if (imgWidth < thresholdWidth && imgHeight < thresholdHeight) {
            setShow(false);
        }
    };

    const handleError = () => {
        setShow(false);
    };

    if (!show) {
        return null;
    }

    return (
        <img
            src={url}
            alt={alt}
            onLoad={checkDimensions}
            onError={handleError}
        />
    );
};

export default ConditionalImage;